import './subpage_wrapper.less';

import React, { Component } from 'react';
import autobind from 'class-autobind';

import first from 'lodash/first';
import filter from 'lodash/filter';
import toPairs from 'lodash/toPairs';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import mapValues from 'lodash/mapValues';

import { isElInViewport } from 'zoomforth_zfutils/dom_utils.js';

import SubpageMultisectionWrapper from './subpage_wrapper.multisection.jsx';
import SubpageFullPageSectionWrapper from './subpage_wrapper.fullpage_section.jsx';
import SubpageFullPageTextSectionWrapper from './subpage_wrapper.fullpage_text_section.jsx';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

class SubpageWrapper extends Component {

  constructor() {
    super();
    autobind(this);
  }

  componentDidMount() {
    window.jQuery(APP_CONTAINER_SELECTOR).on('scroll.subpage_anchor_link_tracker', this.scrollListener);
    window.jQuery(window).on('resize.subpage_anchor_link_tracker', this.resizeListener);
    
    this.refreshScrollIndicator();
  }

  componentWillUnmount() {
    window.jQuery(APP_CONTAINER_SELECTOR).off('scroll.subpage_anchor_link_tracker', this.scrollListener);
    window.jQuery(window).off('resize.subpage_anchor_link_tracker', this.resizeListener);
  }

  resizeListener() { this.refreshScrollIndicator(); }
  scrollListener() { this.refreshScrollIndicator(); }

  refreshScrollIndicator(){
    const { submenuItems, onActiveAnchorLinksChange } = this.props;

    if (isEmpty(submenuItems)) {
      return;
    }

    window.clearTimeout(this.onScrollTimer);

    this.onScrollTimer = setTimeout(() => {
      const isAnchorActiveById = {};

      const anchorElements = {};

      forEach(submenuItems, (submenuItem) => {
        isAnchorActiveById[submenuItem.id] = false;

        const isAnchorSection = !submenuItem.appAction.contentUuid;

        const anchorElementId = isAnchorSection ?
          `#section-id-${submenuItem.appAction.sectionId}`
        :
          `#uuid-${submenuItem.appAction.contentUuid}`
        ;

        const element = window.jQuery(anchorElementId)[0];

        if (element) {
          anchorElements[submenuItem.id] = element;
        }
      });

      // The goal here is to try and select the topmost element as the active
      // anchor link on scroll. This has a limitation that if two tiles are
      // next to each other in a grid then it will show the first one as
      // selected. That's an edge case we can accept. The more likely scenario
      // is that sections are shown as active correctly.
      //
      // We do this by finding the top of the element and assuming that the
      // first element greater than 0 is the topmost in the viewport. This
      // should be reasonable and looks nice in practice.
      const submenuItemIdByRectTop = mapValues(anchorElements, (el)=> {
        if (!isElInViewport(el, { partially: true })) {
          return -1000;
        }

        const rect = el.getBoundingClientRect();

        return rect.top;
      });

      const visibleSubmenuItems = filter(toPairs(submenuItemIdByRectTop), ([ submenuItemId, top ])=> top > 0);

      const [ topmostSubmenuItemId, rectTop ] = isEmpty(visibleSubmenuItems) ? [null, 0] : first(visibleSubmenuItems);

      if (topmostSubmenuItemId) {
        isAnchorActiveById[topmostSubmenuItemId] = true;
      }

      onActiveAnchorLinksChange(isAnchorActiveById, submenuItems);

    }, 10); // Only update this as often as we need to. No need to waste resources.
  }

  render() {
    const {
      sections,
      isFullPage,
      sectionsSelectedContent,
      ...props
    } = this.props;

    if (isFullPage) {
      const section = first(sections);
      const currentContentItem = first(sectionsSelectedContent);
      const hasDisplayableContent = !section.isHidden && !!currentContentItem;
    
      if (section.type === 'text') {
        // historically text sections have stretched the full height of the page.
        // there is a specific width that gets applied to a fullpage text section but
        // the height is inconsequential and no tracking is done so we have a special
        // wrapper for these text sections.
        return (
          <SubpageFullPageTextSectionWrapper
            key={props.currentSubpage.id}
            {...props}
          />
        );
      
      } else {
        return (
          <SubpageFullPageSectionWrapper
            key={props.currentSubpage.id} 
            hasDisplayableContent={hasDisplayableContent}
            {...props}
          />
        );
      }
    }

    return (
      <SubpageMultisectionWrapper
        key={props.currentSubpage.id}
        {...props}
      />
    );
  }

}

export default SubpageWrapper;
